/* 🤖 this file was generated by svg-to-ts*/
export const iconSpinnerCircle: {
  name: 'spinner_circle';
  data: string;
} = {
  name: 'spinner_circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><circle cx="8" cy="8" r="7" fill="none"/><circle cx="8" cy="8" r="7" fill="none"/></svg>`,
};
